var _g, _ellipse, _ellipse2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 134,
    viewBox: "0 0 115 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2832,
    cy: 128.049,
    rx: 29,
    ry: 5.95065,
    fill: "#7670C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9647 104.468C74.079 104.294 74.2451 104.16 74.4384 104.084C90.9994 97.5225 102.695 81.5174 102.695 62.8142C102.695 38.266 82.5474 18.3658 57.6946 18.3658C32.8418 18.3658 12.6946 38.266 12.6946 62.8142C12.6946 81.5174 24.3898 97.5225 40.9508 104.084C41.1441 104.16 41.3102 104.294 41.4245 104.468L56.0239 126.653C56.8141 127.854 58.5751 127.854 59.3653 126.653L73.9647 104.468Z",
    fill: "#484556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.35083 56.9136C0.35083 51.3907 4.82798 46.9136 10.3508 46.9136H16.3508C18.56 46.9136 20.3508 48.7044 20.3508 50.9136V80.6321C20.3508 82.8412 18.56 84.6321 16.3508 84.6321H10.3508C4.82798 84.6321 0.35083 80.1549 0.35083 74.6321V56.9136Z",
    fill: "#7670C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3508 0C25.8706 0 0.35083 25.5198 0.35083 57V65.5103H7.45996V65.5111H107.242V65.5103H114.351V57C114.351 25.5198 88.8311 0 57.3508 0ZM107.242 65.5103V57.6161C107.242 30.062 84.9053 7.72488 57.3512 7.72488C29.797 7.72488 7.45996 30.062 7.45996 57.6161V65.5103H107.242Z",
    fill: "#7670C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3508 50.9136C94.3508 48.7044 96.1417 46.9136 98.3508 46.9136H104.351C109.874 46.9136 114.351 51.3907 114.351 56.9136V74.6321C114.351 80.1549 109.874 84.6321 104.351 84.6321H98.3508C96.1417 84.6321 94.3508 82.8412 94.3508 80.6321V50.9136Z",
    fill: "#7670C6"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.2832,
    cy: 64.9368,
    rx: 17,
    ry: 16.8741,
    fill: "#B9B6E0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.2832,
    cy: 64.9368,
    rx: 13,
    ry: 12.9037,
    fill: "#78728F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.947 77.7358L31.8594 56.0483C32.91 54.9512 34.153 54.0373 35.5348 53.36L47.1233 76.4683C45.8387 77.1106 44.432 77.5476 42.947 77.7358Z",
    fill: "#948EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7959 75.469L37.6202 52.5525C38.1632 52.3945 38.7209 52.2707 39.2908 52.1837L50.1012 74.4184C49.6898 74.7955 49.2538 75.1466 48.7959 75.469Z",
    fill: "#948EAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.7362db276c81db23cea1336b59967755.svg";
export { ForwardRef as ReactComponent };